module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/jxt-xmpp/~/babel-runtime/core-js/object/assign.js
// module id = 486
// module chunks = 2